export default {
  errorResponse: null,
  successResponse: null,
  isLoading: false,
};
